import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { TopNavigation } from '@/components/layout/TopNavigation';
import { ConnectionsTab } from '@/components/connections/ConnectionsTab';
import { UserConnectionsList } from '@/components/connections/UserConnectionsList';
import { useMyConnections } from '@/hooks/useMyConnections';
import { useI18n } from '@/contexts/I18nContext';

interface UserConnectionsProps {
  userId: string;
  isOwnProfile: boolean;
}

export const UserConnections: React.FC<UserConnectionsProps> = ({ userId, isOwnProfile }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: connectionsData, refetch, hasNextPage, isFetchingNextPage, fetchNextPage } = useMyConnections();
  const connections = connectionsData?.pages?.flat() || [];
  const { t } = useI18n();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <TopNavigation variant="subtle" />
      <div className="min-h-screen bg-[#160C0C] text-white">
        
        {/* Header */}
        <div className="pt-16">
          <div className="flex items-center justify-between p-4 border-b border-[#281B1B]">
            <button onClick={handleBack} className="flex items-center gap-2 text-white/80 hover:text-white transition-colors">
              <ArrowLeft className="w-5 h-5" />
              <span className="text-sm font-medium">{t('recognitions.back')}</span>
            </button>
            <h1 className="text-lg font-semibold">{t('profile.connections')}</h1>
            <div className="w-20"></div>
          </div>

          {/* Content */}
          <div className="p-4">
            {isOwnProfile ? (
              <ConnectionsTab 
                connections={connections} 
                refetchConnections={async () => { await refetch(); }}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                fetchNextPage={fetchNextPage}
                noContainer={true} 
              />
            ) : (
              <UserConnectionsList userId={userId} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}; 